import React, { Component } from "react";

import {
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Radio
} from "react-bootstrap";
import FaTrash from "react-icons/lib/fa/trash";

class UserEdit extends Component {
  render() {
    const groups = this.props.groups.map(group => {
      return <option value={group.id + "#" + group.name}>{group.name}</option>;
    });

    const groupsOfUser = this.props.groupsOfUser.map(group => {
      return (
        <tr>
          <td>{group.name}</td>
          <td>{group.swaggerPermission}</td>
          <td>
            <Button
              bsStyle="danger"
              onClick={() => this.props.onGroupDelete(group.id)}>
              <FaTrash />
            </Button>
          </td>
        </tr>
      );
    });

    const user =
      this.props.user === null ? null : (
        <form>
          <FormGroup>
            <ControlLabel>Username</ControlLabel>
            <FormControl
              id="username"
              type="text"
              placeholder="Enter a username"
              value={this.props.user.username}
              onChange={event => {
                this.props.onChange(event);
              }}/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Last Name</ControlLabel>
            <FormControl
              id="lastname"
              type="text"
              placeholder="Enter a last name"
              value={this.props.user.lastname}
              onChange={event => {
                this.props.onChange(event);
              }}/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>First Name</ControlLabel>
            <FormControl
              id="firstname"
              type="text"
              placeholder="Enter a first name"
              value={this.props.user.firstname}
              onChange={event => {
                this.props.onChange(event);
              }}/>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Password</ControlLabel>
            <FormControl
              id="password"
              type="password"
              placeholder="Enter a password"
              defaultValue=""
              onChange={event => {
                this.props.onChange(event);
              }}/>
          </FormGroup>
          <table responsive className="users-table">
            <thead>
              <tr>
                <th className="users-table-th-name">Name</th>
                <th className="users-table-th-name">Permission</th>
                <th className="users-table-th-button">Delete</th>
              </tr>
            </thead>
            <tbody>{groupsOfUser}</tbody>
          </table>
          <FormGroup>
            <FormControl
              componentClass="select"
              placeholder="Select a group"
              onChange={event => {
                this.props.onGroupChange(event);
              }}>
              <option value="">Choose a group</option>
              {groups}
            </FormControl>
          </FormGroup>
          <FormGroup>
            <Radio
              onChange={event => {
                this.props.onGroupChange(event);
              }}
              id="READ"
              name="radioGroup"
              inline
              checked>
              READ
            </Radio>{" "}
            <Radio
              onChange={event => {
                this.props.onGroupChange(event);
              }}
              id="WRITE"
              name="radioGroup"
              inline>
              WRITE
            </Radio>
          </FormGroup>
          <Button bsStyle="success" onClick={() => this.props.onGroupSubmit()}>
            Add to the group
          </Button>
          <FormGroup>
            <Checkbox
              defaultChecked={this.props.user.isAdmin}
              onChange={event => {
                this.props.onChange(event);
              }}
              id="isAdmin">
              is Admin
            </Checkbox>
          </FormGroup>
          <Button onClick={() => this.props.onSubmit()}>Submit</Button>
        </form>
      );

    return (
      <div>
        <Button
          className="users-create-button"
          bsStyle="success"
          onClick={() => this.props.onCreate()}>
          Create a user
        </Button>
        {user}
      </div>
    );
  }
}

export default UserEdit;



// WEBPACK FOOTER //
// ./src/components/users/UserEdit.js